module.exports = __webpack_public_path__ + "static/media/icons.dd44cb1e.svg";